<div class="panel">
  <!-- Size -->
  <section class="section">

    <div class="row">
      <app-number-stepper label="Height" [currentValue]="properties.height" (valueChange)=onHeightChange($event)></app-number-stepper>
    </div>
    <div class="row">
      <app-number-stepper label="Number of columns" [min]="1" [currentValue]="properties.columns" (valueChange)=onColumnChange($event)></app-number-stepper>
    </div>
  </section>


  <!-- Spacing (margin + padding share one section) -->
  <section class="section">
    <div class="section-header spacing-header">
      <div class="section-title">
        <mat-icon>crop_free</mat-icon>
        <span>Spacing</span>
      </div>

      <mat-button-toggle-group
        [(ngModel)]="spacingMode"
        (ngModelChange)="setSpacingMode($event)"
        class="mode-toggle"
      >
        <mat-button-toggle value="margin">Margin</mat-button-toggle>
        <mat-button-toggle value="padding">Padding</mat-button-toggle>
      </mat-button-toggle-group>
    </div>


    <div class="spacing-inputs">
      <app-four-input 
        (valueChange)="handleSpacingChange($event)"
        [left]="spacingMode === 'margin' ? properties.marginLeft : properties.paddingLeft" 
        [top]="spacingMode === 'margin' ? properties.marginTop:  properties.paddingTop" 
        [right]="spacingMode === 'margin' ? properties.marginRight : properties.paddingRight" 
        [bottom]="spacingMode === 'margin' ? properties.marginBottom :  properties.paddingBottom"       
        ></app-four-input>
    </div>
  </section>

  <!-- Appearance -->
  <section class="section">
    <div class="section-header">
      <mat-icon>palette</mat-icon>
      <span>Appearance</span>
    </div>

    <div class="row color-row">
      <input
        type="color"
        class="swatch"
        [(ngModel)]="properties.backgroundColor"
        (ngModelChange)="update()"
        aria-label="Background colour"
      />

      <mat-form-field appearance="outline" class="field">
        <mat-label>Hex</mat-label>
        <input matInput [(ngModel)]="properties.backgroundColor" (ngModelChange)="update()" />
      </mat-form-field>
    </div>

    <div class="slider-row">
      <span class="slider-label">Opacity</span>
      <mat-slider min="0" max="100" step="1" class="slider" discrete>
        <input matSliderThumb [(ngModel)]="properties.opacity" (ngModelChange)="update()" />
      </mat-slider>
      <span class="slider-value">{{ properties.opacity }}%</span>
    </div>

    <div class="slider-row">
      <span class="slider-label">Radius</span>
      <mat-slider min="0" max="48" step="1" class="slider" discrete>
        <input matSliderThumb [(ngModel)]="properties.borderRadius" (ngModelChange)="update()" />
      </mat-slider>
      <span class="slider-value">{{ properties.borderRadius }}px</span>
    </div>
  </section>
</div>
